import type { Error } from '@/domains/shoppingCart/AddToCart/AddToCart.interfaces';

import {
  cartError,
  otherError,
  outOfStock,
  productError,
} from '../../translations';
import { APP_CODE } from './constants';

export const formatErrorMessage = (error: Error) => {
  const {
    CART_ALREADY_PAID,
    CART_NOT_FOUND,
    INVALID_PRODUCT,
    PRODUCT_NOT_FOUND,
    PRODUCT_OUT_OF_STOCK,
  } = APP_CODE;

  switch (error.appCode) {
    case CART_ALREADY_PAID:
      return cartError;
    case CART_NOT_FOUND:
      return cartError;
    case INVALID_PRODUCT:
      return productError;
    case PRODUCT_NOT_FOUND:
      return productError;
    case PRODUCT_OUT_OF_STOCK:
      return outOfStock;
    default:
      return otherError;
  }
};
